module.exports = __webpack_public_path__ + "img/gf3.a9e3091b.png";